var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithoutVehiclesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239.833,
    height: 224.512,
    viewBox: "0 0 239.833 224.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.509,
    y1: 0.997,
    x2: 0.509,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.813,
    y1: 0.841,
    x2: 0.813,
    y2: -0.159,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.78,
    y1: 0.849,
    x2: 1.78,
    y2: -0.151,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_ionic-md-search",
    x: 165.167,
    y: 136.018,
    width: 74.667,
    height: 74.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.071
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8368",
    "data-name": "Grupo 8368",
    transform: "translate(-965 -460.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8304",
    "data-name": "Grupo 8304",
    transform: "translate(965 460.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6014",
    "data-name": "Rect\\xE1ngulo 6014",
    width: 125.66,
    height: 173.621,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 19.875, 38.959)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8300",
    "data-name": "Grupo 8300",
    transform: "translate(22.568 15.912)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6015",
    "data-name": "Rect\\xE1ngulo 6015",
    width: 121.413,
    height: 167.753,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 0, 25.471)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6016",
    "data-name": "Rect\\xE1ngulo 6016",
    width: 118.322,
    height: 164.046,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 24.337, 42.266)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6017",
    "data-name": "Rect\\xE1ngulo 6017",
    width: 58.698,
    height: 14.219,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 52.145, 29.026)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5283",
    "data-name": "Trazado 5283",
    d: "M444.94,91.453a8.4,8.4,0,1,0,9.776,6.493A8.3,8.3,0,0,0,444.94,91.453Zm2.78,12.968a4.848,4.848,0,1,1,3.611-5.751,4.79,4.79,0,0,1-3.611,5.751Z",
    transform: "translate(-367.015 -82.163)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6018",
    "data-name": "Rect\\xE1ngulo 6018",
    width: 57.462,
    height: 13.592,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 52.622, 28.3)",
    fill: "#05ce9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5284",
    "data-name": "Trazado 5284",
    d: "M445.2,91.453a8.031,8.031,0,1,0,9.538,6.168A8.031,8.031,0,0,0,445.2,91.453Zm2.657,12.393a4.635,4.635,0,1,1,3.56-5.5,4.635,4.635,0,0,1-3.56,5.5Z",
    transform: "translate(-367.277 -82.162)",
    fill: "#05ce9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6019",
    "data-name": "Rect\\xE1ngulo 6019",
    width: 125.66,
    height: 173.621,
    transform: "translate(74.153 33.616)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8301",
    "data-name": "Grupo 8301",
    transform: "translate(76.278 36.552)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6020",
    "data-name": "Rect\\xE1ngulo 6020",
    width: 121.413,
    height: 167.753,
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6021",
    "data-name": "Rect\\xE1ngulo 6021",
    width: 118.322,
    height: 164.046,
    transform: "translate(77.822 37.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6022",
    "data-name": "Rect\\xE1ngulo 6022",
    width: 58.698,
    height: 14.219,
    transform: "translate(107.789 30.675)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5285",
    "data-name": "Trazado 5285",
    d: "M646.526,118a8.4,8.4,0,1,0,8.206,8.4A8.306,8.306,0,0,0,646.526,118Zm0,13.25a4.848,4.848,0,1,1,4.733-4.848,4.79,4.79,0,0,1-4.733,4.825Z",
    transform: "translate(-509.388 -101.205)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6023",
    "data-name": "Rect\\xE1ngulo 6023",
    width: 57.462,
    height: 13.592,
    transform: "translate(108.408 30.065)",
    fill: "#05ce9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5286",
    "data-name": "Trazado 5286",
    d: "M646.961,118a8.031,8.031,0,1,0,8.031,8.031A8.031,8.031,0,0,0,646.961,118Zm0,12.666a4.639,4.639,0,1,0,0-.014Z",
    transform: "translate(-509.823 -101.205)",
    fill: "#05ce9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8302",
    "data-name": "Grupo 8302",
    transform: "translate(1.866 211.93)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6024",
    "data-name": "Rect\\xE1ngulo 6024",
    width: 1.081,
    height: 6.133,
    transform: "translate(2.525)",
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6025",
    "data-name": "Rect\\xE1ngulo 6025",
    width: 1.081,
    height: 6.133,
    transform: "translate(6.133 2.527) rotate(90)",
    fill: "#47e6b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8303",
    "data-name": "Grupo 8303",
    transform: "translate(127.296)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6026",
    "data-name": "Rect\\xE1ngulo 6026",
    width: 1.081,
    height: 6.133,
    transform: "translate(2.525)",
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6027",
    "data-name": "Rect\\xE1ngulo 6027",
    width: 1.081,
    height: 6.133,
    transform: "translate(6.133 2.525) rotate(90)",
    fill: "#47e6b1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5287",
    "data-name": "Trazado 5287",
    d: "M950.022,826.073a1.325,1.325,0,0,1-.739-1.6.639.639,0,0,0,.029-.147h0a.664.664,0,0,0-1.193-.44h0a.638.638,0,0,0-.075.129,1.326,1.326,0,0,1-1.6.739.642.642,0,0,0-.147-.029h0a.664.664,0,0,0-.44,1.193h0a.638.638,0,0,0,.129.075,1.326,1.326,0,0,1,.739,1.6.635.635,0,0,0-.029.147h0a.664.664,0,0,0,1.193.44h0a.638.638,0,0,0,.075-.129,1.326,1.326,0,0,1,1.6-.739.643.643,0,0,0,.147.029h0a.664.664,0,0,0,.44-1.193h0A.637.637,0,0,0,950.022,826.073Z",
    transform: "translate(-728.307 -603.933)",
    fill: "#4d8af0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5288",
    "data-name": "Trazado 5288",
    d: "M315.612,621.013a1.326,1.326,0,0,1-.739-1.6.637.637,0,0,0,.029-.147h0a.664.664,0,0,0-1.193-.44h0a.638.638,0,0,0-.075.129,1.326,1.326,0,0,1-1.6.739.635.635,0,0,0-.147-.029h0a.664.664,0,0,0-.44,1.193h0a.638.638,0,0,0,.129.075,1.325,1.325,0,0,1,.739,1.6.636.636,0,0,0-.029.147h0a.664.664,0,0,0,1.193.44h0a.64.64,0,0,0,.075-.129,1.326,1.326,0,0,1,1.6-.739.642.642,0,0,0,.147.029h0a.664.664,0,0,0,.44-1.193h0A.639.639,0,0,0,315.612,621.013Z",
    transform: "translate(-276.314 -457.836)",
    fill: "#fdd835",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5289",
    "data-name": "Trazado 5289",
    d: "M844.022,121.693a1.325,1.325,0,0,1-.739-1.6.642.642,0,0,0,.029-.147h0a.664.664,0,0,0-1.193-.44h0a.638.638,0,0,0-.075.129,1.326,1.326,0,0,1-1.6.739.638.638,0,0,0-.147-.029h0a.664.664,0,0,0-.44,1.193h0a.638.638,0,0,0,.129.075,1.326,1.326,0,0,1,.739,1.6.639.639,0,0,0-.029.147h0a.664.664,0,0,0,1.193.44h0a.639.639,0,0,0,.075-.129,1.326,1.326,0,0,1,1.6-.739.639.639,0,0,0,.147.029h0a.664.664,0,0,0,.44-1.193h0A.638.638,0,0,0,844.022,121.693Z",
    transform: "translate(-652.786 -102.089)",
    fill: "#fdd835",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_815",
    "data-name": "Elipse 815",
    cx: 2.165,
    cy: 2.165,
    r: 2.165,
    transform: "translate(231.5 88.257)",
    fill: "#f55f44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_816",
    "data-name": "Elipse 816",
    cx: 2.165,
    cy: 2.165,
    r: 2.165,
    transform: "translate(64.178 212.525)",
    fill: "#f55f44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_817",
    "data-name": "Elipse 817",
    cx: 2.165,
    cy: 2.165,
    r: 2.165,
    transform: "translate(209.264 135.057)",
    fill: "#f55f44",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_818",
    "data-name": "Elipse 818",
    cx: 2.165,
    cy: 2.165,
    r: 2.165,
    transform: "translate(22.891 25.539)",
    fill: "#4d8af0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_819",
    "data-name": "Elipse 819",
    cx: 2.165,
    cy: 2.165,
    r: 2.165,
    transform: "translate(0 84.602)",
    fill: "#47e6b1",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-side",
    "data-name": "Icon awesome-car-side",
    d: "M38.25,13.5H37.125L29.476,3.939A4.5,4.5,0,0,0,25.962,2.25H10.922A4.5,4.5,0,0,0,6.744,5.079l-3.369,8.58A4.489,4.489,0,0,0,0,18v7.875A1.125,1.125,0,0,0,1.125,27H4.5A6.75,6.75,0,0,0,18,27h9a6.75,6.75,0,0,0,13.5,0h3.375A1.125,1.125,0,0,0,45,25.875V20.25A6.75,6.75,0,0,0,38.25,13.5Zm-27,16.875A3.375,3.375,0,1,1,14.625,27,3.379,3.379,0,0,1,11.25,30.375ZM16.313,13.5H8.222l2.7-6.75h5.391Zm3.375,0V6.75h6.275l5.4,6.75ZM33.75,30.375A3.375,3.375,0,1,1,37.125,27,3.379,3.379,0,0,1,33.75,30.375Z",
    transform: "translate(1081 559.75)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8306",
    "data-name": "Grupo 8306",
    transform: "translate(-8 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 973, 492.15)",
    filter: "url(#Icon_ionic-md-search)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-search-2",
    "data-name": "Icon ionic-md-search",
    d: "M51.272,45.776H48.279l-1.124-.938a24.837,24.837,0,0,0,5.8-15.948,24.229,24.229,0,1,0-24.135,24.39,25.074,25.074,0,0,0,15.9-5.816l1.122.938v3L64.555,70.167l5.612-5.629Zm-22.451,0A16.886,16.886,0,1,1,45.659,28.891,16.792,16.792,0,0,1,28.822,45.776Z",
    transform: "translate(165.17 136.02)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_820",
    "data-name": "Elipse 820",
    cx: 17,
    cy: 17.5,
    rx: 17,
    ry: 17.5,
    transform: "translate(1150 640)",
    fill: "#e2e0e0",
    opacity: 0.42
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutVehiclesIcon);
export default __webpack_public_path__ + "static/media/without-vehicles-icon.d410c3bdd694ec7fbaa389f1bf2710b4.svg";
export { ForwardRef as ReactComponent };